import { Link } from "react-router-dom";
import { Card, Container, Row, Col } from "react-bootstrap";
import { useGetDashboardCountsQuery } from "../redux/api/dashboardApi";
import FullPageLoader from "components/FullPageLoader/FullPageLoader";

function Dashboard() {
  const { data, isLoading, isError } = useGetDashboardCountsQuery();

  // Default values
  const counts = data || {
    users: 0,
    events: 0,
    gallery: 0,
    documents: 0,
  };

  if (isLoading) {
    return <FullPageLoader />;
  }

  return (
    <div className="pt-3 pt-md-5">
      <Container fluid>
        <Row>
          <Col xl={3} sm={6}>
            <Link to="/users-managment">
              <Card className="card-stats">
                <Card.Body>
                  <div className="d-flex">
                    <div className="numbers">
                      <p className="card-category">Users</p>
                      <Card.Title as="h4">{counts.users || 0}</Card.Title>
                    </div>
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-single-02"></i>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Link>
          </Col>
          <Col xl={3} sm={6}>
            <Link to="/events">
              <Card className="card-stats">
                <Card.Body>
                  <div className="d-flex">
                    <div className="numbers">
                      <p className="card-category">Upcoming Events</p>
                      <Card.Title as="h4">{counts.events || 0}</Card.Title>
                    </div>
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-paper-2"></i>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Link>
          </Col>
          <Col xl={3} sm={6}>
            <Link to="/gallery">
              <Card className="card-stats">
                <Card.Body>
                  <div className="d-flex">
                    <div className="numbers">
                      <p className="card-category">Gallery</p>
                      <Card.Title as="h4">{counts.gallery || 0}</Card.Title>
                    </div>
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-camera-20"></i>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Link>
          </Col>
          <Col xl={3} sm={6}>
            <Link to="/documents">
              <Card className="card-stats">
                <Card.Body>
                  <div className="d-flex">
                    <div className="numbers">
                      <p className="card-category">Documents</p>
                      <Card.Title as="h4">{counts.documents || 0}</Card.Title>
                    </div>
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-notes"></i>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Dashboard;
